// extracted by mini-css-extract-plugin
export default {"img":"followDoctor_img__Q1SF5","conWidth":"followDoctor_conWidth__cMsX-","following":"followDoctor_following__3NsHu"};